import WarningIcon from '@shared/assets/icons/WarningIcon';
import InfoIcon from '@shared/assets/icons/InfoIcon';
import HelpIcon from '@shared/assets/icons/HelpIcon';
import CheckIcon from '@shared/assets/icons/CheckIcon';
import ExportIcon from '@shared/assets/icons/ExportIcon';
import ActivePlanEnIcon from '@shared/assets/icons/ActivePlanEnIcon';
import ActivePlanRuIcon from '@shared/assets/icons/ActivePlanRuIcon';
import TelegramIcon from '@shared/assets/icons/TelegramIcon';
import ArrowRightIcon from '@shared/assets/icons/ArrowRightIcon';
import PasswordIcon from '@shared/assets/icons/PasswordIcon';
import VisibleIcon from '@shared/assets/icons/VisibleIcon';
import VisibleOffIcon from '@shared/assets/icons/VisibleOffIcon';
import RefreshIcon from '@shared/assets/icons/RefreshIcon';
import EmailInputIcon from '@shared/assets/icons/EmailInputIcon';
import EditIcon from '@shared/assets/icons/EditIcon';
import HintIcon from '@shared/assets/icons/HintIcon';
import UserInputIcon from '@shared/assets/icons/UserInputIcon';
import CalendarIcon from '@shared/assets/icons/CalendarIcon';
import WalletInputIcon from '@shared/assets/icons/WalletInputIcon';
import CopyIcon from '@shared/assets/icons/CopyIcon';
import ChargedIcon from '@shared/assets/icons/ChargedIcon';
import HoldIcon from '@shared/assets/icons/HoldIcon';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TransactionsIcon from '@shared/assets/icons/TransactionsIcon';
import TransferIcon from '@shared/assets/icons/TransferIcon';
import ArchiveIcon from '@shared/assets/icons/ArchiveIcon';
import BlockIcon from '@shared/assets/icons/BlockIcon';
import DeleteIcon from '@shared/assets/icons/DeleteIcon';
import FreezeIcon from '@shared/assets/icons/FreezeIcon';
import SearchIcon from '@shared/assets/icons/SearchIcon';
import CardsIcon from '@shared/assets/icons/CardsIcon';
import ProfileIcon from '@shared/assets/icons/ProfileIcon';
import AnyIcon from '@shared/assets/icons/AnyIcon';
import FilterIcon from '@shared/assets/icons/FilterIcon';
import SupportIcon from '@shared/assets/icons/SupportIcon';
import ReferralsIcon from '@shared/assets/icons/ReferralsIcon';
import NotificationIcon from '@shared/assets/icons/NotificationIcon';
import LogoutIcon from '@shared/assets/icons/LogoutIcon';
import ChatIcon from '@shared/assets/icons/ChatIcon';
import DarkThemeIcon from '@shared/assets/icons/DarkThemeIcon';
import CardInputIcon from '@shared/assets/icons/CardInputIcon';
import UnfreezeIcon from '@shared/assets/icons/UnfreezeIcon';
import ErrorIcon from '@shared/assets/icons/ErrorIcon';
import TeamsIcon from '@shared/assets/icons/TeamsIcon';
import MembersIcon from '@shared/assets/icons/MembersIcon';
import DashboardIcon from '@shared/assets/icons/DashboardIcon';
import AddIcon from '@shared/assets/icons/AddIcon';
import CheckSuccessIcon from '@shared/assets/icons/CheckSuccessIcon';
import UnknownIcon from '@shared/assets/icons/UnknownIcon';
import HugsIcon from '@shared/assets/icons/HugsIcon';
import MoveDuoVertical from '@shared/assets/icons/MoveDuoVertical';
import VisaLogo from '@shared/assets/payments/VisaLogo';
import MasterCardLogo from '@shared/assets/payments/MasterCardLogo';
import SendIcon from '@shared/assets/icons/SendIcon';
import ChevronLeftIcon from '@shared/assets/icons/ChevronLeftIcon';
import FileIcon from '@shared/assets/icons/FileIcon';
import ArrowDownIcon from '@shared/assets/icons/ArrowDownIcon';
import ArrowUpIcon from '@shared/assets/icons/ArrowUpIcon';
import TabLinkIcon from '@shared/assets/icons/TabLinkIcon';
import LockIcon from '@shared/assets/icons/LockIcon';
import EmailIcon from '@shared/assets/icons/EmailIcon';
import ChevronDownIcon from '@shared/assets/icons/ChevronDownIcon';
import CloseIcon from '@shared/assets/icons/CloseIcon';
import FreezeSelectIcon from '@shared/assets/icons/FreezeSelectIcon';
import MinusIcon from '@shared/assets/icons/MinusIcon';
import PlusIcon from '@shared/assets/icons/PlusIcon';
import BalanceIcon from '@shared/assets/icons/BalanceIcon';
import UsdtIcon from '@shared/assets/payments/UsdtIcon';
import ChevronRightIcon from '@shared/assets/icons/ChevronRightIcon';
import BtcIcon from '@shared/assets/payments/BtcIcon';
import SidebarMoreIcon from '@shared/assets/icons/SidebarMoreIcon';
import MasterBalanceIcon from '@shared/assets/icons/MasterBalanceIcon';
import ArrowLeftIcon from '@shared/assets/icons/ArrowLeftIcon';
import ViewCardsIcon from '@shared/assets/icons/ViewCardsIcon';
import EmptyDataIcon from '@shared/assets/icons/EmptyDataIcon';
import VisaCardLogo from '@shared/assets/payments/VisaCardLogo';
import EditCardBg from '@shared/assets/payments/EditCardBg';
import BlockOutlineIcon from '@shared/assets/icons/BlockOutlineIcon';
import UsersGroupIcon from '@shared/assets/icons/UsersGroupIcon';
import HistoryIcon from '@shared/assets/icons/HistoryIcon';
import UsdIcon from '@shared/assets/icons/UsdIcon';
import EurIcon from '@shared/assets/icons/EurIcon';
import TransferVerticalIcon from '@shared/assets/icons/TransferVerticalIcon';
import EyeVisibleIcon from '@shared/assets/icons/EyeVisibleIcon';
import TelegramLogo from '@shared/assets/avatars/TelegramLogo';
import AnyOutlineIcon from '@shared/assets/icons/AnyOutlineIcon';

export const icons = {
  cards: <CardsIcon />, // sidebar menu icon
  dashboard: <DashboardIcon />, // sidebar menu icon
  balance: <BalanceIcon />, // sidebar total balance icon
  transactions: <TransactionsIcon />, // sidebar menu icon
  teams: <TeamsIcon />, // sidebar menu icon
  profile: <ProfileIcon />, // sidebar menu icon
  support: <SupportIcon />, // sidebar menu icon
  referrals: <ReferralsIcon />, // sidebar menu icon
  'dark-theme': <DarkThemeIcon />, // sidebar theme btn
  logout: <LogoutIcon />, // sidebar
  chat: <ChatIcon />, // sidebar
  notification: <NotificationIcon />, // sidebar
  hugs: <HugsIcon />, // move member dialog
  unknown: <UnknownIcon />, // move member dialog
  refresh: <RefreshIcon />, // inputs with edit / change action
  add: <AddIcon />,
  transfer: <TransferIcon />,
  'transfer-vertical': <TransferVerticalIcon />,
  USDT: <UsdtIcon />,
  BTC: <BtcIcon />,
  'card-input': <CardInputIcon />, // dashboard cards icon, card selects
  'chevron-right': <ChevronRightIcon />, // balances from/to table icon
  check: <CheckIcon />,
  'chevron-down': <ChevronDownIcon />, // split button icon
  'sidebar-more': <SidebarMoreIcon />, // sidebar more icon
  'arrow-right': <ArrowRightIcon />,
  'Master balance': <MasterBalanceIcon />, // master balance icon balances
  'Referral balance': <MasterBalanceIcon />, // referral balance icon balances
  'chevron-left': <ChevronLeftIcon />, // sign up page back to login button icon
  'arrow-left': <ArrowLeftIcon />,
  'view-cards': <ViewCardsIcon />, // view cards icon on dashboard total balance mobile
  'empty-data': <EmptyDataIcon />, // empty data icon,
  block: <BlockIcon />, // select transfer cards
  'visa-card': <VisaCardLogo />,
  'edit-card-bg': <EditCardBg />,
  visa: <VisaLogo />,
  'master-card': <MasterCardLogo />,
  'block-outline': <BlockOutlineIcon />, // cards menu icon
  'users-group': <UsersGroupIcon />, // change owner cards menu icon
  history: <HistoryIcon />, // balance history btn icon
  usd: <UsdIcon />,
  eur: <EurIcon />,
  'eye-visible': <EyeVisibleIcon />,
  telegram: <TelegramIcon />,
  'telegram-input': <TelegramLogo />,
  any: <AnyIcon />, // balance bank filter
  'any-outline': <AnyOutlineIcon />, // CurrencyTabs
  'arrow-down': <ArrowDownIcon />,
  'arrow-up': <ArrowUpIcon />,
  warning: <WarningIcon />,
  info: <InfoIcon />,
  error: <ErrorIcon />,
  close: <CloseIcon />,
  help: <HelpIcon />, // Help Display
  success: <CheckIcon />,
  export: <ExportIcon />,
  'active-plan-en': <ActivePlanEnIcon />, // Increase limits dialog
  'active-plan-ru': <ActivePlanRuIcon />, // Increase limits dialog
  password: <PasswordIcon />,
  visible: <VisibleIcon />,
  'visible-off': <VisibleOffIcon />,
  'email-input': <EmailInputIcon />,
  edit: <EditIcon />,
  hint: <HintIcon />,
  'user-input': <UserInputIcon />,
  calendar: <CalendarIcon />,
  'wallet-input': <WalletInputIcon />,
  copy: <CopyIcon />,
  charged: <ChargedIcon />,
  hold: <HoldIcon />,
  more: <MoreVertIcon />,
  archive: <ArchiveIcon />,
  delete: <DeleteIcon />,
  freeze: <FreezeIcon />,
  search: <SearchIcon />,
  filter: <FilterIcon />,
  unfreeze: <UnfreezeIcon />,
  members: <MembersIcon />,
  chart: <DashboardIcon />,
  'check-success': <CheckSuccessIcon />, // MemberInfoDialog, EditMemberDialog, ActivateUserPage
  'move-duo-vertical': <MoveDuoVertical />,
  send: <SendIcon />,
  file: <FileIcon />,
  'tab-link': <TabLinkIcon />, // BalanceDetailsCell
  lock: <LockIcon />, // Sidebar menu lock
  email: <EmailIcon />,
  minus: <MinusIcon />, // Quantity input
  plus: <PlusIcon />, // Quantity input
  'freeze-select': <FreezeSelectIcon />, // Freeze dialog
};
